import React from 'react';
import { Box, Typography, TextField } from '@material-ui/core';
import AssignmentIcon from '@material-ui/icons/Assignment';
import Button from '../../../../../components/Button';

const SurveySection = ({
  questions,
  teleauditStatus,
  answersSubmitted,
  showSaveTest,
  questionResponse,
  postSurveyTeleaudit,
  setAnswersSubmitted,
  handleChoiceChange,
  questionTranslatorType,
  styles,
}) => {
  const [, forceUpdate] = React.useState(0);
  const handleSaveAnswers = () => {
    const inputs = document.querySelectorAll('input[name*="question"]');
    const answers = [];
    const questionShow = questions.filter((q) => q.show).map((q) => q.id);

    inputs.forEach((input) => {
      const { name } = input;
      const arrayName = name.split('_');
      if (!questionShow.includes(parseInt(arrayName[2], 10))) {
        return;
      }
      if (input.type === 'radio' && input.checked) {
        answers.push({
          id: arrayName[2],
          value: input.value,
          type: arrayName[1],
        });
      } else if (input.type === 'text' && input.value) {
        answers.push({
          id: arrayName[2],
          value: input.value,
          type: arrayName[1],
        });
      } else if (input.type === 'number' && input.value) {
        answers.push({
          id: arrayName[2],
          value: input.value,
          type: arrayName[1],
        });
      } else if (input.type === 'date' && input.value) {
        answers.push({
          id: arrayName[2],
          value: input.value,
          type: arrayName[1],
        });
      } else if (input.type === 'checkbox' && input.checked) {
        answers.push({
          id: arrayName[2],
          value: input.value,
          type: arrayName[1],
        });
      }
    });

    postSurveyTeleaudit(
      questionResponse.id,
      questionResponse.Question.surveyTeleauditId,
      questionResponse.SurveyResponse.productId,
      questionResponse.SurveyResponse.categoryCode,
      questionResponse.SurveyResponse.taskInstanceId,
      answers,
      'questions',
    );

    inputs.forEach((inputEl) => {
      const el = inputEl;
      el.readOnly = true;
      el.disabled = true;
    });

    setAnswersSubmitted(true);
  };

  const hasAnswers = () => {
    const inputs = Array.from(
      document.querySelectorAll('input[name*="question"]'),
    );
    const questionShow = questions.filter((q) => q.show).map((q) => q.id);

    return inputs
      .filter((input) => {
        const { name } = input;
        const arrayName = name.split('_');
        return questionShow.includes(parseInt(arrayName[2], 10));
      })
      .some((input) => {
        if (input.type === 'radio' && input.checked) return true;
        if (input.type === 'text' && input.value) return true;
        if (input.type === 'number' && input.value) return true;
        if (input.type === 'date' && input.value) return true;
        if (input.type === 'checkbox' && input.checked) return true;
        return false;
      });
  };

  return (
    <Box mt={2}>
      <Box mt={4} mb={4} display="flex" direction="row" alignItems="center">
        <AssignmentIcon color="primary" />
        <Typography variant="h2">Encuesta</Typography>
      </Box>

      {questions.map(
        (question, index) => (question.show || teleauditStatus === 'done') && (
            <Box key={question.id} mb={2} className={styles.questionCard}>
              <Box
                mb={2}
                display="flex"
                flexDirection="column"
                alignItems="start"
              >
                <Typography
                  variant="h3"
                  fontWeight="bold"
                  style={{ marginBottom: '8px', fontSize: '14px' }}
                >
                  {questionTranslatorType(question.type)}
                </Typography>
                <Typography variant="h3" fontWeight="bold">
                  {index + 1}. {question.title}
                </Typography>
              </Box>

              {question.type === 'short answer' && (
                <TextField
                  name={`question_${question.type}_${question.id}`}
                  type="text"
                  onChange={() => forceUpdate((v) => v + 1)}
                  disabled={teleauditStatus === 'done'}
                  placeholder="Respuesta..."
                  style={{ width: '100%' }}
                />
              )}

              {question.type === 'numeric answer' && (
                <input
                  name={`question_${question.type}_${question.id}`}
                  type="number"
                  disabled={teleauditStatus === 'done'}
                  style={{ width: '100%', padding: '5px' }}
                  placeholder="Respuesta Numerica..."
                />
              )}

              {question.type === 'date' && (
                <input
                  name={`question_${question.type}_${question.id}`}
                  type="date"
                  disabled={teleauditStatus === 'done'}
                  style={{ width: '100%', padding: '5px' }}
                />
              )}

              {question.type === 'simple selection'
                && question.QuestionChoices && (
                  <div>
                    {question.QuestionChoices.map((choice) => (
                      <label
                        key={choice.id}
                        style={{ display: 'block', margin: '12px 0' }}
                      >
                        <input
                          disabled={teleauditStatus === 'done'}
                          type="radio"
                          name={`question_${question.type}_${question.id}`}
                          value={choice.id}
                          style={{ marginRight: '8px' }}
                        />
                        {choice.title}
                      </label>
                    ))}
                  </div>
              )}

              {question.type === 'multiple selection'
                && question.QuestionChoices && (
                  <div>
                    {question.QuestionChoices.map((choice) => (
                      <label
                        key={choice.id}
                        style={{ display: 'block', margin: '12px 0' }}
                      >
                        <input
                          disabled={teleauditStatus === 'done'}
                          type="checkbox"
                          name={`question_${question.type}_${question.id}`}
                          value={choice.id}
                          style={{ marginRight: '8px' }}
                        />
                        {choice.title}
                      </label>
                    ))}
                  </div>
              )}

              {(question.type === 'yes-no question'
                || question.type === 'yes/no question')
                && question.QuestionChoices && (
                  <div>
                    {question.QuestionChoices.map((choice) => (
                      <label
                        key={choice.id}
                        style={{ display: 'block', margin: '12px 0' }}
                      >
                        <input
                          type="radio"
                          onChange={() => handleChoiceChange(question, choice)}
                          disabled={teleauditStatus === 'done'}
                          name={`question_${question.type}_${question.id}`}
                          value={choice.id}
                          style={{ marginRight: '8px' }}
                        />
                        {choice.title}
                      </label>
                    ))}
                  </div>
              )}
            </Box>
        ),
      )}

      {!answersSubmitted && teleauditStatus === 'pending' && showSaveTest && (
        <Button
          onClick={handleSaveAnswers}
          text="Guardar Respuestas"
          backgroundColor={
            hasAnswers()
              ? 'theme-custom-solidButtonBackground'
              : 'theme-custom-disabledButtonBackground'
          }
          color="theme-custom-solidButtonText"
          variant="contained"
          height="40px"
          width="170px"
          borderRadius="10px"
          disabled={!hasAnswers()}
        />
      )}
    </Box>
  );
};

export default SurveySection;
